import { getBaseQuery, getBaseUrl } from '../../Utils';
import { createApi } from '@reduxjs/toolkit/query/react';
import { HomeWorkspaceTiles, AddOneWorkspace, FindWorkspacePayload, FindWorkspaceResponse } from '../../Types/HomePageInterface'

function convertToFormData<T extends Record<string, any>>(data: T): FormData {
  const formData = new FormData();
  
  Object.entries(data).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (typeof item === 'object' && item !== null) {
          // Stringify objects before appending
          formData.append(`${key}[]`, JSON.stringify(item));
        } else {
          formData.append(`${key}[]`, String(item));
        }
      });
    } else if (typeof value === 'object' && value !== null) {
      // Stringify single objects
      formData.append(key, JSON.stringify(value));
    } else {
      formData.append(key, String(value));
    }
  });
  return formData;
}


const baseUrl = `${getBaseUrl()}api/v3/workspace`;

export const HomeWorkspaceApi = createApi({
    reducerPath:'Home',
    baseQuery: getBaseQuery(baseUrl),
    endpoints: (builder) => ({
        GetMyWorkspace: builder.mutation<HomeWorkspaceTiles[], void>({
            query: () => ({
              url: '/my',
              method: 'GET',
            }),
            transformResponse: (response: any) => {
              return response.data ? response.data : [];
            },
          }),
        FindWorkspace: builder.mutation<FindWorkspaceResponse, FindWorkspacePayload>({
            query: (body) => ({
              url: '/search',
              method: 'POST',
              body: convertToFormData(body)
            }),
            transformResponse: (response: any) => {
              console.log("Raw API Response:", response);
              return response;
            },
          }),
        AddWorkSpace: builder.mutation<HomeWorkspaceTiles, AddOneWorkspace>({
          query: (body)=>({
            url: "",
            method: 'POST',
            body: convertToFormData(body)
          })
        }),
        SortOrder: builder.mutation<HomeWorkspaceTiles[], { dashBoardIds:any[]}>({
          query: (body) => ({
            url: '/sortorder',
            method: 'POST',
            body: convertToFormData(body), // Converts the payload to FormData
          }),
          transformResponse: (response: any) => {
            return response.data ? response.data : [];
          },
        }),
    })
})

export const {
    useGetMyWorkspaceMutation,
    useAddWorkSpaceMutation,
    useSortOrderMutation,
    useFindWorkspaceMutation
} = HomeWorkspaceApi;